import React from "react";
import { Col, Row, Tooltip, InputNumber, Form, Button } from "antd";
import original_data from "./testData";

function pickHex(color1, color2, weight) {
  var w1 = weight;
  var w2 = 1 - w1;
  var rgb = [
    Math.round(color1[0] * w1 + color2[0] * w2),
    Math.round(color1[1] * w1 + color2[1] * w2),
    Math.round(color1[2] * w1 + color2[2] * w2),
  ];
  return rgb;
}

const green = [0, 255, 0];
const white = [255, 255, 255];
const red = [255, 0, 0];

const RentPricingCalculator = () => {
  const text = (
    <p style={{ color: "#000" }}>
      Each box displays the vacancy-adjusted daily revenue you will earn for a
      given rent price and vacancy time combination (based on a 12-month lease).
      Boxes with higher values will help you maximize your total annual revenue.
    </p>
  );

  const data = original_data.slice(); // Full set
  return (
    <div className="RentPricingCalculator">
      <p>
        The table below shows the average daily revenue based on a variety of
        monthly rent amounts and days of vacancy. Use this table to better
        understand the tradeoff between rent amount and days vacant.
        <Tooltip
          placement="bottom"
          title={text}
          color={["#fff"]}
          trigger={["click"]}
        >
          <i
            className="fa-solid fa-circle-question"
            style={{ color: "#006eb7", cursor: "pointer" }}
          ></i>
        </Tooltip>
      </p>
      <br />
      <Form autoComplete="off">
        <Row justify="center">
          <Col span={8}>
            <Form.Item label="Market Rent" name="marketRent">
              <InputNumber
                style={{
                  width: "100%",
                }}
                prefix={<i className="fa-solid fa-dollar-sign"></i>}
              />
            </Form.Item>
          </Col>
          <Col span={8} offset={1}>
            <Form.Item label="Days Vacant" name="DaysVacant">
              <InputNumber
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              wrapperCol={{
                offset: 2,
                span: 16,
              }}
            >
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row>
        <Col span={2}>
          <p>Rent Price</p>
        </Col>
        <Col span={21} offset={1}>
          <p>Days Vacant</p>
          <table className="ConditionalTable">
            <tbody>
              {/* {data.map((item, index) => {
                if (index === 0) {
                  return (
                    <tr>
                      {[...Array(item.length)].map((x, i) => {
                        return <td>{item[i]}</td>;
                      })}
                    </tr>
                  );
                }
                return (
                  <tr>
                    {[...Array(item.length)].map((x, i) => {
                      let backgroundColor;
                      const ratio = index / (item.length / 2);
                      if (ratio > 1) {
                        backgroundColor = pickHex(red, white, ratio - 1);
                      } else {
                        backgroundColor = pickHex(white, green, ratio);
                      }
                      backgroundColor = `rgba(${backgroundColor.join(",")})`;
                      // <td>{item[i]}</td>
                      if (i === 0) {
                        return <td>{item[i]}</td>;
                      }
                      return <td style={{ backgroundColor }}>{item[i]}</td>;
                    })}
                  </tr>
                );
              })} */}
            </tbody>
          </table>
        </Col>
      </Row>
    </div>
  );
};

export default RentPricingCalculator;
